module.exports = __webpack_public_path__ + "img/icecream_half.550545d4.svg";